// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import FloatingLabelInput from "../components/FloatingLabelInput";
// import DateInput from "../components/DateInput";
// import InputMask from "react-input-mask";
// import { Container, Paper, Box, Grid, Typography, Checkbox, FormControlLabel, Alert, Snackbar, Tooltip, IconButton } from "@mui/material";
// import Button from "@mui/material/Button";
// import { FiLoader } from "react-icons/fi";
// import { HiEye, HiEyeOff } from "react-icons/hi";
// import Dropdown from "../components/Dropdown";
// import { useAuth } from '../context/AuthContext';
// import SearchableDropdown from "../components/SearchableDropdown";
// import { Check as CheckIcon, Close as CloseIcon } from "@mui/icons-material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// import { DoneAll as DoneAllIcon } from "@mui/icons-material";
// import { toProperCase } from "../utils/formatRows";

// // Helper function to calculate future date in dd-mm-yyyy format based on days input
// const getFutureDate = (days) => {
//   const today = new Date();
//   today.setDate(today.getDate() + Number(days));
//   const dd = String(today.getDate()).padStart(2, "0");
//   const mm = String(today.getMonth() + 1).padStart(2, "0");
//   const yyyy = today.getFullYear();
//   return `${dd}-${mm}-${yyyy}`;
// };

// const categoryOptions = [
//   { id: "1", name: "Admin" },
//   { id: "2", name: "Team Leader" },
//   { id: "3", name: "User" },
// ];

// const UserMaster = ({ onPopupCancel, connectionString }) => {

//   const { user, selectedCompany } = useAuth();
//   const userId = user?.UserId || null;
//   const path = connectionString;
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { mode } = location.state || { mode: "insert" };
//   const UID = location?.state?.UserId;
//   const companyId = selectedCompany?.CompId || null;
//   const userCategory = user?.UserCategory || null;
//   const AppRegID = user?.AppRegID || null;

//   // State variables
//   const [employeeName, setEmployeeName] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [emailId, setEmailId] = useState("");
//   const [Designation, setDesignation] = useState("");
//   const [userName, setUserName] = useState("");
//   const [password, setPassword] = useState("");
//   const [DateOfBirth, setDateOfBirth] = useState("");
//   const [joiningDate, setJoiningDate] = useState(new Date().toISOString().split("T")[0]);
//   const [days, setDays] = useState("");
//   const [enableDays, setEnableDays] = useState(false);
//   const [category, setCategory] = useState("");
//   const [IsActive, setIsActive] = useState(true);
//   const [errors, setErrors] = useState({});
//   const [updateMessage, setUpdateMessage] = useState("");
//   const [updateStatus, setUpdateStatus] = useState("success");
//   const [showPassword, setShowPassword] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [originalCategory, setOriginalCategory] = useState("");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [usernameError, setUsernameError] = useState("");
//   const [usernameValid, setUsernameValid] = useState(false);
//   const [usernameCheckLoading, setUsernameCheckLoading] = useState(false);
//   const [selectedTeamLeaders, setSelectedTeamLeaders] = useState([]);
//   const [cacheLoaded, setCacheLoaded] = useState(false);
//   const [isPasswordError, setIsPasswordError] = useState(false)

//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

//   //timeout state variables
//   const [usernameCheckTimeout, setUsernameCheckTimeout] = useState(null);
//   const [mobileCheckTimeout, setMobileCheckTimeout] = useState(null); //  Add this
//   const [emailCheckTimeout, setEmailCheckTimeout] = useState(null); //  Add this

//   //states for email validation (for warning)
//   const [emailTouched, setEmailTouched] = useState(false);
//   const [emailInvalid, setEmailInvalid] = useState(false);
//   const [emailDomainWarning, setEmailDomainWarning] = useState("");

//   //states to check unique mobile number
//   const [mobileError, setMobileError] = useState("");
//   const [mobileValid, setMobileValid] = useState(false);
//   const [mobileCheckLoading, setMobileCheckLoading] = useState(false);

//   const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };

//   // Check if all required fields are filled
//   const isFormComplete = () => {
//     return (
//       employeeName.trim() !== "" &&
//       mobileNumber.trim() !== "" &&
//       emailId.trim() !== "" &&
//       Designation.trim() !== "" &&
//       userName.trim() !== "" &&
//       password.trim() !== "" &&
//       DateOfBirth.trim() !== "" &&
//       joiningDate.trim() !== "" &&
//       category !== "" &&
//       !emailInvalid && //
//       !mobileError && // No mobile error
//       !usernameError  // No username error
//     );
//   };


//   const EMAIL_SUGGESTIONS = [ 'nomail@gmail.com', ];
//   const [showEmailSuggestions, setShowEmailSuggestions] = useState(false);

//   //email validation helper
//   const isValidEmail = (email = "") => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

//   //common email domains
//   const COMMON_EMAIL_DOMAINS = [ "gmail.com", "yahoo.com", "outlook.com", "hotmail.com", "icloud.com", "live.com", "protonmail.com", ];

//   // Levenshtein distance calculator
//   const levenshteinDistance = (str1, str2) => {
//     const matrix = [];

//     for (let i = 0; i <= str2.length; i++) {
//       matrix[i] = [i];
//     }

//     for (let j = 0; j <= str1.length; j++) {
//       matrix[0][j] = j;
//     }

//     for (let i = 1; i <= str2.length; i++) {
//       for (let j = 1; j <= str1.length; j++) {
//         if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
//           matrix[i][j] = matrix[i - 1][j - 1];
//         } else {
//           matrix[i][j] = Math.min(
//             matrix[i - 1][j - 1] + 1, // substitution
//             matrix[i][j - 1] + 1,     // insertion
//             matrix[i - 1][j] + 1      // deletion
//           );
//         }
//       }
//     }

//     return matrix[str2.length][str1.length];
//   };

//   //Improved domain typo detector using Levenshtein distance
//   const findClosestDomain = (domain) => {
//     if (!domain) return null;

//     // exact match
//     if (COMMON_EMAIL_DOMAINS.includes(domain)) return null;

//     // Find the closest domain with a distance of 1 or 2
//     let closestDomain = null;
//     let minDistance = Infinity;

//     for (const commonDomain of COMMON_EMAIL_DOMAINS) {
//       const distance = levenshteinDistance(domain, commonDomain);

//       // Only suggest if distance is 1 or 2 (likely typo)
//       if (distance <= 2 && distance < minDistance) {
//         minDistance = distance;
//         closestDomain = commonDomain;
//       }
//     }

//     return closestDomain;
//   };


//   // Set default category based on logged-in user's role
//   useEffect(() => {
//     console.log("Location state:", location.state);
//     if (mode === "insert") {
//       if (userCategory === "Admin") {
//         setCategory("2"); // Team Leader
//       } else if (userCategory === "Team Leader") {
//         setCategory("3"); // User
//       }
//     }
//   }, [mode, userCategory]);

//   // Cleanup timeouts on unmount
//   useEffect(() => {
//     return () => {
//       if (mobileCheckTimeout) clearTimeout(mobileCheckTimeout);
//       if (usernameCheckTimeout) clearTimeout(usernameCheckTimeout);
//       if (emailCheckTimeout) clearTimeout(emailCheckTimeout);
//     };
//   }, [mobileCheckTimeout, usernameCheckTimeout, emailCheckTimeout]);

//   // Global cache
//   let membersCache = [];

//   // SINGLE useEffect for edit mode — does everything perfectly
//   useEffect(() => {
//     if (mode !== "edit" || !UID) return;

//     const fetchUserAndParents = async () => {
//       try {
//         // Step 1: Get user details
//         const userRes = await axios.get(`${path}/api/user/${UID}`);
//         const userData = userRes.data;
//         console.log("Fetched user:", userData);

//         // Fill form
//         setEmployeeName(userData.EmployeeName || "");
//         setMobileNumber(userData.MobileNo ? userData.MobileNo.toString() : "");
//         setEmailId(userData.emailId || "");
//         setDesignation(userData.Designation || "");
//         setUserName(userData.UserName || "");
//         setPassword(userData.Password || "");
//         setDateOfBirth(userData.DateOfBirth || "");
//         setJoiningDate(userData.JoiningDate || new Date().toISOString().split("T")[0]);
//         const matched = categoryOptions.find(o => o.name === userData.UserCategory);
//         setCategory(matched ? matched.id : "");
//         setOriginalCategory(userData.UserCategory || "");
//         setIsActive(!!userData.IsActive);


//         if (userData.IsActive === 0) {
//           setEnableDays(true);
//           setDays(userData.FreezeDays?.toString() || "0");
//         } else {
//           setEnableDays(false);
//           setDays("");
//         }

//         // Step 2: If user has parentUserIds → fetch all members and filter
//         if (userData.parentUserIds && userData.parentUserIds.length > 0) {
//           const allMembers = await fetchTeamLeaders();
//           const matchedParents = allMembers.filter(member => userData.parentUserIds.includes(member.UserId) );
//           console.log("Matched parents:", matchedParents);
//           setSelectedTeamLeaders(matchedParents);
//         }

//       } catch (error) {
//         console.error("Error in edit mode:", error);
//         setUpdateMessage("Failed to load user");
//         setUpdateStatus("error");
//       }
//     };

//     fetchUserAndParents();
//   }, [mode, UID, path, companyId]);

//   console.log("days",)

//   // Add this function in your component
//   const checkUsername = async (userNameValue) => {
//     if (!userNameValue.trim()) {
//       setUsernameError("");
//       setUsernameValid(false);
//       return;
//     }

//     setUsernameCheckLoading(true);

//     try {
//       const res = await axios.post(`${path}/api/checkUsername`, { userName: userNameValue.trim(), });

//       if (!res.data.unique) {
//         setUsernameError( `Taken. Try: ${res.data.suggestions?.join(", ") || ""}` );
//         setUsernameValid(false);
//       } else {
//         setUsernameError("");
//         setUsernameValid(true);
//       }
//     } catch (error) {
//       console.error("Username check failed:", error);
//       setUsernameError("Check failed");
//       setUsernameValid(false);
//     } finally {
//       setUsernameCheckLoading(false);
//     }
//   };

//   // function to check check mobile number
//   const checkMobileNumber = async (mobileValue) => {
//     // Don't check if mobile is empty or invalid format
//     if (!mobileValue.trim() || !/^\d{10}$/.test(mobileValue)) {
//       setMobileError("");
//       setMobileValid(false);
//       return;
//     }

//     setMobileCheckLoading(true);

//     try {
//       const res = await axios.get(`${path}/api/user-check-mobile`, {
//         params: { mobileNo: mobileValue.trim() }
//       });

//       console.log(res)

//       // Adjust based on your API response structure
//       if (!res.data.success) {
//         setMobileError("");
//         setMobileValid(false);
//       } else {
//         setMobileError("");
//         setMobileValid(true);
//       }
//     } catch (error) {
//       console.error("Mobile check failed:", error);
//       setMobileError("Mobile number already exist! Try different one.");
//       setMobileValid(false);
//     } finally {
//       setMobileCheckLoading(false);
//     }
//   };

//   // Smart fetch function that ALSO caches data
//   const fetchTeamLeaders = async (search = "") => {
//     if (!companyId || !path) return [];

//     try {
//       const res = await axios.get(`${path}/api/members`, {
//         params: { companyId, search: search.trim() || undefined }
//       });

//       const data = res.data || [];
//       console.log("Fetched members:", data);

//       // Update global cache
//       if (!search) {
//         membersCache = data;
//         console.log("Members cached:", membersCache.length, "users");
//       }

//       return data;
//     } catch (err) {
//       console.error("Failed to load team leaders", err);
//       return [];
//     }
//   };

//   // Form validation
//   const validateFormData = () => {
//     let newErrors = {};

//     if (!employeeName.trim()) newErrors.employeeName = "Employee Name is required";

//     if (!mobileNumber.trim()) newErrors.mobileNumber = "Mobile Number is required";
//     else if (!/^\d{10}$/.test(mobileNumber)) newErrors.mobileNumber = "Mobile Number must be 10 digits";

//     if (!emailId.trim()) newErrors.emailId = "Email ID is required";
//     else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailId)) newErrors.emailId = "Enter a valid email address";

//     if (!Designation.trim()) newErrors.Designation = "Designation is required";

//     if (!userName.trim()) newErrors.userName = "User Name is required";

//     if (!password.trim()) {
//       newErrors.password = "Password is required";
//       setIsPasswordError(true);
//     } else if (password.length < 6) {
//       newErrors.password = "Password must be at least 6 characters";
//       setIsPasswordError(true);
//     } else {
//       // ✅ password is valid
//       setIsPasswordError(false);
//     }

//     if (!DateOfBirth.trim())
//       newErrors.DateOfBirth = "Date of Birth is required";

//     if (!joiningDate.trim())
//       newErrors.joiningDate = "Joining Date is required";

//     if (!category)
//       newErrors.category = "Category is required";

//     setErrors(newErrors);
//     console.log("Validation Errors:", newErrors);

//     return Object.keys(newErrors).length === 0;
//   };

//   // Form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     console.log("API Path:", path);
//     console.log("Props → loggedInUser:", user);
//     console.log("Props → companyData:", selectedCompany);
//     console.log("Mode:", mode, "UserId:", UID);

//     // Add mobile validation check (for unique mobile number)
//     if (mobileError) {
//       setUpdateMessage("Please fix the mobile number error");
//       setUpdateStatus("error");
//       return;
//     }

//     // Validate connectionString
//     if (!path) {
//       setUpdateMessage("API connection string is missing");
//       setUpdateStatus("error");
//       setIsSubmitting(false);
//       return;
//     }

//     // Validate companyId
//     if (!companyId) {
//       setUpdateMessage("Company ID is missing");
//       setUpdateStatus("error");
//       setIsSubmitting(false);
//       return;
//     }

//     // Validate form data
//     if (!validateFormData()) {
//       console.log("Validation failed, errors:", errors);
//       setIsSubmitting(false);
//       return;
//     }

//     const selectedCategory = categoryOptions.find(option => option.id === category);
//     if (!selectedCategory) {
//       setUpdateMessage("Invalid category selected");
//       setUpdateStatus("error");
//       setIsSubmitting(false);
//       return;
//     }

//     // Ensure userName is not empty
//     if (!userName.trim()) {
//       setUpdateMessage("User Name cannot be empty");
//       setUpdateStatus("error");
//       setIsSubmitting(false);
//       return;
//     }

//     const payload = { AppRegID, employeeName, mobileNumber, emailId, Designation, userName, password, DateOfBirth, joiningDate, category: selectedCategory.name, IsActive, companyId, addUserId: userId, editUserId: mode === "edit" ? userId : undefined, userId: mode === "edit" ? userId : undefined, days: enableDays ? Number(days) : undefined, ...(selectedTeamLeaders.length > 0 && { parentUserIds: selectedTeamLeaders.map(u => u.UserId) }) };
//     console.log("Submitting payload:", payload);
//     try {
//       if (mode === "edit" && originalCategory === "Admin" && selectedCategory.name !== "Admin") {
//         setUpdateMessage("This user details cannot be modified");
//         setUpdateStatus("error");
//         setSnackbarOpen(true);
//         setIsSubmitting(false);
//         return;
//       }

//       if (mode === "edit" && selectedCategory.name === "User") {
//         try {
//           // const { data: teamData } = await axios.get(`${path}/api/teamcount/${UID}?companyId=${companyId}`);
//           // console.log("Team count data:", teamData);
//           // if (teamData.count > 1) {
//           //   setUpdateMessage("Cannot change category to 'User' because this user has team members. Please remove team members before changing.");
//           //   setUpdateStatus("error");
//           //   setSnackbarOpen(true);
//           //   setIsSubmitting(false);
//           //   setIsPasswordError(false)
//           //   return;
//           // }
//         } catch (error) {
//           console.error("Error fetching team count:", error);
//           setUpdateMessage("Failed to verify team count");
//           setUpdateStatus("error");
//           setSnackbarOpen(true);
//           setIsSubmitting(false);
//           return;
//         }
//       }

//       if (mode === "edit") {
//         if (!UID) {
//           setUpdateMessage("UserId is missing, cannot update");
//           setUpdateStatus("error");
//           setIsSubmitting(false);
//           return;
//         }
//         const response = await axios.put(`${path}/api/useredit/${UID}`, payload);
//         console.log("Update response:", response.data);

//         if (typeof onPopupCancel === 'function') {
//           console.log("Calling onPopupCancel");
//           onPopupCancel();
//         } else {
//           console.log("Navigating to /main/v3/userdetails");
//           // setUpdateMessage("User details updated successfully!");
//           // setUpdateStatus("success");
//           setSnackbar({ open: true, message: "User updated successfully!", severity: 'success', });
//           setTimeout(() => { navigate(-1) }, 600)
//         }
//       } else {
//         const response = await axios.post(`${path}/api/insertUser`, payload);
//         console.log("Insert response:", response.data);
//         if (response.data.success) {
//           setEmployeeName("");
//           setMobileNumber("");
//           setEmailId("");
//           setDesignation("");
//           setUserName("");
//           setPassword("");
//           setDateOfBirth("");
//           setJoiningDate(new Date().toISOString().split("T")[0]);
//           setCategory("");
//           setIsActive(true);
//           setErrors({});
//           if (typeof onPopupCancel === 'function') {
//             console.log("Calling onPopupCancel");
//             onPopupCancel();
//           } else {
//             console.log("Navigating to /main/v3/userdetails");
//             // setUpdateMessage("User created successfully!");
//             // setUpdateStatus("success");
//             setSnackbar({ open: true, message: "User created successfully!", severity: 'success', });
//             setTimeout(() => { navigate(-1) }, 600)
//           }
//         } else {
//           // setUpdateMessage("Failed to create user: " + (response.data.message || "Unknown error"));
//           setUpdateStatus("error");
//         }
//       }
//     } catch (error) {
//       console.error("Error processing user details:", error);
//       if (error.response) {
//         console.error("Response data:", error.response.data);
//         console.error("Response status:", error.response.status);
//         setSnackbarMessage(error.response.data.message || "Server error");
//       } else {
//         setSnackbarMessage("Network error or server is unreachable");
//       }
//       setUpdateMessage(error.response?.data?.message || "Server error");
//       setUpdateStatus("error");
//       setSnackbarOpen(true);
//     }
//     setIsSubmitting(false);
//   };

//   const handleCancel = () => {
//     if (typeof onPopupCancel === 'function') {
//       console.log("Calling onPopupCancel");
//       onPopupCancel();
//     } else {
//       console.log("Navigating to /main/v3/userdetails");
//       navigate('/main/v3/userdetails');
//     }
//   };

//   const handleCategoryChange = (selectedOption) => {
//     setCategory(selectedOption.id);
//   };

//   return (
//     <Container maxWidth="sm">
//       <Paper elevation={3} sx={{ p: 3, mt: 2 }}>
//         {/* <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600, mt: -1.8, mb: 1 }}> {mode === 'edit' ? 'Edit User' : 'Add New User'} </Typography> */}

//         <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 0.6, mt: -1.5 }}>
//           {/* Back arrow — mobile/tablet only */}
//           <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 0, display: { xs: 'flex', md: 'none' }, color: 'text.secondary', p: 0.5, }} >
//             <ArrowBackIcon fontSize="small" />
//           </IconButton>

//           <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600 }}>
//             {mode === 'edit' ? 'Edit User' : 'Add New User'}
//           </Typography>
//         </Box>

//         {updateMessage && (<Alert severity={updateStatus} sx={{ mb: 2 }}> {updateMessage} </Alert>)}

//         <Box component="form" noValidate onSubmit={handleSubmit}>
//           <Grid container spacing={1.5} direction="column">
//             <Grid item xs={12}> <FloatingLabelInput label="Employee Name" name="EmployeeName" type="text" value={toProperCase(employeeName)} onChange={(e) => setEmployeeName(toProperCase(e.target.value))} error={Boolean(errors.employeeName)} helperText={errors.employeeName} required
//               InputLabelProps={{ sx: requiredAsteriskStyle }}
//               sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, "& .MuiFormLabel-asterisk": { color: "gray", }, }} 
//             /> </Grid>

//             <Grid item xs={12}>
//               <Tooltip title={mobileCheckLoading ? "Checking mobile number..." : ""} arrow disableHoverListener={!mobileCheckLoading} slotProps={{ tooltip: { sx: { fontSize: "0.9rem" }, }, }} >
//                 <Box>
//                   <InputMask mask="9999999999" maskChar="" value={mobileNumber}
//                     onChange={(e) => {
//                       const newValue = e.target.value;
//                       setMobileNumber(newValue);
//                       setMobileError("");
//                       setMobileValid(false);

//                       // ✅ Clear previous timeout
//                       if (mobileCheckTimeout) {
//                         clearTimeout(mobileCheckTimeout);
//                       }

//                       // ✅ Set new timeout - validate after 1000ms of no typing
//                       const timeoutId = setTimeout(() => {
//                         checkMobileNumber(newValue);
//                       }, 1000);

//                       setMobileCheckTimeout(timeoutId);
//                     }}
//                     onBlur={() => checkMobileNumber(mobileNumber)} // ✅ Keep onBlur
//                   >
//                     {(inputProps) => (
//                       <FloatingLabelInput {...inputProps} required label="Mobile No" name="MobileNo" type="text" error={Boolean(errors.mobileNumber) || Boolean(mobileError)} helperText={errors.mobileNumber || mobileError}
//                         sx={{
//                           '& .MuiOutlinedInput-root': {
//                             height: 38, display: 'flex', alignItems: 'center',
//                             '& fieldset': { borderColor: mobileError ? '#ef4444' : undefined, borderWidth: mobileError ? 2 : 1, },
//                             '&:hover fieldset': { borderColor: mobileError ? '#ef4444' : undefined, },
//                             '&.Mui-focused fieldset': { borderColor: mobileError ? '#ef4444' : undefined, },
//                           },
//                         }}
//                         InputProps={{
//                           endAdornment: mobileCheckLoading ? (
//                             <FiLoader className="animate-spin" size={20} style={{ color: '#3b82f6' }} />
//                           ) : mobileError ? (
//                             <CloseIcon sx={{ color: '#ef4444', fontSize: 24 }} />
//                           ) : mobileValid ? (
//                             <DoneAllIcon sx={{ color: '#25D366', fontSize: 24 }} />
//                           ) : null,
//                         }}
//                       />
//                     )}
//                   </InputMask>
//                 </Box>
//               </Tooltip>
//             </Grid>

//             {/* Updated Email Field with Better Domain Warning */}
//             <Grid item xs={12} mt={mobileError ? 2.5 : 0}>
//               <Tooltip title={emailTouched && emailDomainWarning ? `Looks like spelling mistake. Did you mean ${emailDomainWarning}?` : emailTouched && emailInvalid ? "Invalid email format" : ""} arrow disableHoverListener={!(emailTouched && (emailInvalid || emailDomainWarning))} slotProps={{ tooltip: { sx: { fontSize: "0.9rem" }, }, }} >
//                 <Box sx={{ position: "relative" }} component="form" autoComplete="off">
//                   <FloatingLabelInput required label="Email ID" name="emailId" type="email" value={emailId} spellCheck="false" autoComplete="off"  // Add this inputProps={{ autoComplete: "off", form: { autoComplete: "off", }, }}
//                     onChange={(e) => {
//                       const newValue = e.target.value;
//                       setEmailId(newValue);
//                       setEmailInvalid(false);
//                       setEmailDomainWarning("");

//                       if (emailCheckTimeout) clearTimeout(emailCheckTimeout);

//                       const timeoutId = setTimeout(() => {
//                         if (!newValue.trim()) {
//                           setEmailInvalid(false);
//                           setEmailDomainWarning("");
//                           return;
//                         }

//                         if (!isValidEmail(newValue)) {
//                           setEmailInvalid(true);
//                           setEmailTouched(true);
//                           setEmailDomainWarning("");
//                           return;
//                         }

//                         setEmailInvalid(false);
//                         setEmailTouched(true);

//                         const domain = newValue.split("@")[1]?.toLowerCase();
//                         const suggestion = findClosestDomain(domain);

//                         if (suggestion && domain !== suggestion) {
//                           setEmailDomainWarning(suggestion);
//                         } else {
//                           setEmailDomainWarning("");
//                         }
//                       }, 1000);

//                       setEmailCheckTimeout(timeoutId);
//                     }}
//                     onFocus={() => setShowEmailSuggestions(true)}
//                     onBlur={() => {
//                       // ⏳ allow click on suggestion
//                       setTimeout(() => {
//                         setShowEmailSuggestions(false);

//                         setEmailTouched(true);

//                         if (!emailId.trim()) {
//                           setEmailInvalid(false);
//                           setEmailDomainWarning("");
//                           return;
//                         }

//                         if (!isValidEmail(emailId)) {
//                           setEmailInvalid(true);
//                           setEmailDomainWarning("");
//                           return;
//                         }

//                         setEmailInvalid(false);

//                         const domain = emailId.split("@")[1]?.toLowerCase();
//                         const suggestion = findClosestDomain(domain);

//                         if (suggestion && domain !== suggestion) {
//                           setEmailDomainWarning(suggestion);
//                         } else {
//                           setEmailDomainWarning("");
//                         }
//                       }, 150);
//                     }}
//                     error={Boolean(errors.emailId) || emailInvalid}
//                     helperText={errors.emailId}
//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         height: 38, display: 'flex', alignItems: 'center',
//                         "& fieldset": {
//                           borderColor: emailTouched && emailDomainWarning ? "#ffc400" : emailTouched && emailInvalid ? "#ef4444" : undefined, borderWidth: emailTouched && (emailInvalid || emailDomainWarning) ? 2 : 1,
//                         },
//                       },
//                     }}
//                   />

//                   {/* 🔹 Tooltip-style email suggestions */}
//                   {showEmailSuggestions && (
//                     <Box sx={{ position: "absolute", top: "calc(100% + 8px)", left: 12, bgcolor: "#fff", borderRadius: 2, px: 1, py: 0.5, zIndex: 20, boxShadow: "0px 6px 18px rgba(0,0,0,0.15)", minWidth: 260, }} >
//                       {/* arrow */}
//                       <Box sx={{ position: "absolute", top: -6, left: 16, width: 12, height: 12, bgcolor: "#fff", transform: "rotate(45deg)", }} />

//                       {EMAIL_SUGGESTIONS
//                         .filter( (item) => !emailId || item.toLowerCase().includes(emailId.toLowerCase()) )
//                         .map((item) => (
//                           <Box key={item} sx={{ px: 1.5, py: 0.75, fontSize: 13, borderRadius: 1, cursor: "pointer", "&:hover": { backgroundColor: "#f0f4ff" }, }} onMouseDown={() => { setEmailId(item); setEmailInvalid(false); setEmailDomainWarning(""); }} > {item} </Box>
//                         ))}
//                     </Box>
//                   )}
//                 </Box>

//               </Tooltip>
//             </Grid>

//             <Grid item xs={12}> <FloatingLabelInput required label="Designation" name="Designation" type="text" value={toProperCase(Designation)} onChange={(e) => setDesignation(toProperCase(e.target.value))} error={Boolean(errors.Designation)} helperText={errors.Designation} sx={{
//               '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
//               '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
//               "& .MuiFormLabel-asterisk": { color: "gray", },
//             }} /> </Grid>

//             <Grid item xs={12}>
//               <Tooltip title={usernameCheckLoading ? "Checking availability..." : ""} arrow disableHoverListener={!usernameCheckLoading} slotProps={{ tooltip: { sx: { fontSize: "0.9rem" }, }, }} >
//                 <Box>
//                   <FloatingLabelInput required label="User Name" name="UserName" type="text" value={userName}
//                     onChange={(e) => {
//                       const newValue = e.target.value;
//                       setUserName(newValue);
//                       setUsernameError("");
//                       setUsernameValid(false);

//                       // ✅ Clear previous timeout
//                       if (usernameCheckTimeout) {
//                         clearTimeout(usernameCheckTimeout);
//                       }

//                       // ✅ Set new timeout - validate after 1000ms of no typing
//                       const timeoutId = setTimeout(() => {
//                         checkUsername(newValue);
//                       }, 1000);

//                       setUsernameCheckTimeout(timeoutId);
//                     }}
//                     onBlur={() => {
//                       checkUsername(userName); // ✅ Keep onBlur
//                     }}
//                     error={Boolean(errors.userName) || Boolean(usernameError)}
//                     helperText={errors.userName || usernameError}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         height: 38, display: 'flex', alignItems: 'center',
//                         '& fieldset': { borderColor: usernameError ? '#ef4444' : undefined, borderWidth: usernameError ? 2 : 1, },
//                         '&:hover fieldset': { borderColor: usernameError ? '#ef4444' : undefined, },
//                         '&.Mui-focused fieldset': { borderColor: usernameError ? '#ef4444' : undefined, },
//                       },
//                     }}
//                     InputProps={{
//                       endAdornment: usernameCheckLoading ? (
//                         <FiLoader className="animate-spin" size={20} style={{ color: '#3b82f6' }} />
//                       ) : usernameError ? (
//                         <CloseIcon sx={{ color: '#ef4444', fontSize: 24 }} />
//                       ) : usernameValid ? (
//                         <DoneAllIcon sx={{ color: '#25D366', fontSize: 24 }} />
//                       ) : null,
//                     }}
//                   />
//                 </Box>
//               </Tooltip>
//             </Grid>

//             <Grid item size={{ xs: 12 }} mt={usernameError ? 2.5 : 0}>
//               <FloatingLabelInput required label="Password" name="Password" type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} error={Boolean(errors.password)} helperText={errors.password}
//                 InputProps={{
//                   endAdornment: ( <Box sx={{ cursor: "pointer" }} onClick={() => setShowPassword(!showPassword)}> {showPassword ? <HiEyeOff size={20} /> : <HiEye size={20} />} </Box> ),
//                 }}
//                 sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, "& .MuiFormLabel-asterisk": { color: "gray", }, }}
//               />
//             </Grid>

//             <Grid container justifyContent={"space-between"} mt={isPasswordError ? 2.5 : 0}>
//                <Grid item size={{xs:6}}>
//                 <DateInput fullWidth margin="none" required
//                   label={
//                     <>
//                       Date of Birth{" "}
//                       <span style={{ color: "#d32f2f", fontWeight: 500 }}>*</span>
//                     </>
//                   }
//                   name="DateOfBirth" value={DateOfBirth} onChange={(e) => setDateOfBirth(e.target.value)} error={Boolean(errors.DateOfBirth)} helperText={errors.DateOfBirth} sx={{ height: 38 }}
//                 />
//               </Grid>

//               <Grid item size={{xs:6}}>
//                 <DateInput fullWidth margin="none" required
//                   label={
//                     <>
//                       Joining Date{" "}
//                       <span style={{ color: "#d32f2f", fontWeight: 500 }}>*</span>
//                     </>
//                   }
//                   name="JoiningDate" value={joiningDate} onChange={(e) => setJoiningDate(e.target.value)} error={Boolean(errors.joiningDate)} helperText={errors.joiningDate} sx={{ height: 38 }}
//                 />
//               </Grid>
//             </Grid>

//             <Grid item xs={12}>
//               <Dropdown id="category" name="category" required={true} label={
//                 <>
//                   Category
//                 </>
//               } valueKey="id" labelKey="name" value={category} options={categoryOptions} onChange={handleCategoryChange} InputLabelProps={{ sx: requiredAsteriskStyle }} fullWidth disabled={false} />
//               {errors.category && (
//                 <Typography variant="caption" color="error"> {errors.category} </Typography>
//               )}
//             </Grid>

//             <Grid item xs={12}>
//               <SearchableDropdown label="Assign to Members" value={selectedTeamLeaders} onChange={setSelectedTeamLeaders} fetchOptions={fetchTeamLeaders} valueKey="UserId" labelKey="EmployeeName" placeholder="Search and select multiple members..." error={Boolean(errors.teamLeaders)} helperText={errors.teamLeaders || "You can assign multiple members"} />
//             </Grid>

//             <Grid item xs={12} mt={-2} mb={-1.5}>
//               <FormControlLabel label="Active"
//                 control={
//                   <Checkbox checked={IsActive} color="primary"
//                     onChange={(e) => {
//                       const newVal = e.target.checked;
//                       setIsActive(newVal);
//                       if (newVal) setEnableDays(false);
//                     }}
//                   />
//                 }
//               />
//             </Grid>

//             {mode === "edit" && (
//               <>
//                 <Grid item xs={12}>
//                   <FormControlLabel label="Freeze"
//                     control={
//                       <Checkbox color="primary" checked={enableDays}
//                         onChange={(e) => {
//                           const newVal = e.target.checked;
//                           setEnableDays(newVal);
//                           if (newVal) setIsActive(false);
//                         }}
//                       />
//                     }
//                   />
//                 </Grid>

//                 <Grid item xs={12}> <FloatingLabelInput label="No. Days" name="days" type="number" value={days} onChange={(e) => setDays(e.target.value)} disabled={!enableDays} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, "& .MuiFormLabel-asterisk": { color: "inherit", }, }} /> </Grid>
//                 <Grid item xs={12}> <FloatingLabelInput label="Future Date" value={days ? getFutureDate(days) : ""} disabled sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, "& .MuiFormLabel-asterisk": { color: "inherit", }, }} /> </Grid>
//               </>
//             )}

//             <Grid item xs={12} mb={-0.5}>
//               <Button fullWidth variant="contained" color="primary" type="submit" disabled={isSubmitting || !isFormComplete()}
//               >
//                 {isSubmitting ? (
//                   <Box display="flex" alignItems="center" justifyContent="center">
//                     <FiLoader className="animate-spin" style={{ marginRight: 8 }} />
//                     Processing...
//                   </Box>
//                 ) : mode === "edit" ? "Update" : "SUBMIT"}
//               </Button>
//             </Grid>

//             <Grid item xs={12} mb={-0.5}> <Button fullWidth variant="contained" color="error" onClick={handleCancel} > Close </Button> </Grid>
//           </Grid>
//         </Box>
//       </Paper>

//       <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} >
//         <Alert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: "100%" }} >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>

//       <Snackbar open={snackbar.open} autoHideDuration={2000} onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
//         <Alert onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} severity={snackbar.severity} variant="filled">
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Container>
//   );
// };

// export default UserMaster;



//updated code divided into steppers

import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Alert, Snackbar, Box, Stepper, Step, StepLabel } from "@mui/material";
import { useAuth } from '../context/AuthContext';
import { useRights } from '../context/RightsContext';
import { toProperCase } from "../utils/formatRows";
import UserDetailsStep from "./UserDetailsStep";
import UserCompanyAccessStep from "./UserCompanyAccessStep";
import UserRightsStep from "./UserRightsStep";

const getFutureDate = (days) => {
  const today = new Date();
  today.setDate(today.getDate() + Number(days));
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yyyy = today.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

const categoryOptions = [
  { id: "1", name: "Admin" },
  { id: "2", name: "Team Leader" },
  { id: "3", name: "User" },
];

const COMMON_EMAIL_DOMAINS = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com", "icloud.com", "live.com", "protonmail.com"];
const EMAIL_SUGGESTIONS = ['nomail@gmail.com'];
const STEPS = ["User Details", "Company Access", "User Rights"];

const UserMaster = ({ onPopupCancel, connectionString }) => {
  const { user, selectedCompany, isSuperAdmin } = useAuth();
  const { canAccess, showAccessDenied } = useRights() || {};
  const userId = user?.UserId || null;
  const path = connectionString;
  const navigate = useNavigate();
  const location = useLocation();
  const { mode } = location.state || { mode: "insert" };
  const UID = location?.state?.UserId;
  const companyId = selectedCompany?.CompId || null;
  const userCategory = user?.UserCategory || null;
  const AppRegID = user?.AppRegID || null;

  // Category options filtered by who is logged in
  const filteredCategoryOptions = isSuperAdmin
    ? categoryOptions                                              // Super Admin: Admin, TL, User
    : userCategory === "Admin"
      ? categoryOptions.filter(o => o.name !== "Admin")          // Admin: TL, User
      : categoryOptions.filter(o => o.name === "User");          // Team Leader: User only

  // ─── Step state ───────────────────────────────────────────────
  const [currentStep, setCurrentStep] = useState(1);
  const [insertedUID, setInsertedUID] = useState(null);
  const [grantedCompanies, setGrantedCompanies] = useState(null); // set by step 2, used by step 3

  // ─── Form field states ────────────────────────────────────────
  const [employeeName, setEmployeeName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [emailId, setEmailId] = useState("");
  const [Designation, setDesignation] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [DateOfBirth, setDateOfBirth] = useState("");
  const [joiningDate, setJoiningDate] = useState(new Date().toISOString().split("T")[0]);
  const [days, setDays] = useState("");
  const [enableDays, setEnableDays] = useState(false);
  const [category, setCategory] = useState("");
  const [IsActive, setIsActive] = useState(true);
  const [selectedTeamLeaders, setSelectedTeamLeaders] = useState([]);

  // ─── UI / validation states ───────────────────────────────────
  const [errors, setErrors] = useState({});
  const [updateMessage, setUpdateMessage] = useState("");
  const [updateStatus, setUpdateStatus] = useState("success");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [originalCategory, setOriginalCategory] = useState("");
  const [isPasswordError, setIsPasswordError] = useState(false);
  const [cacheLoaded, setCacheLoaded] = useState(false);

  // ─── Snackbar states ──────────────────────────────────────────
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  // ─── Timeout states ───────────────────────────────────────────
  const [usernameCheckTimeout, setUsernameCheckTimeout] = useState(null);
  const [mobileCheckTimeout, setMobileCheckTimeout] = useState(null);
  const [emailCheckTimeout, setEmailCheckTimeout] = useState(null);

  // ─── Username states ──────────────────────────────────────────
  const [usernameError, setUsernameError] = useState("");
  const [usernameValid, setUsernameValid] = useState(false);
  const [usernameCheckLoading, setUsernameCheckLoading] = useState(false);

  // ─── Mobile states ────────────────────────────────────────────
  const [mobileError, setMobileError] = useState("");
  const [mobileValid, setMobileValid] = useState(false);
  const [mobileCheckLoading, setMobileCheckLoading] = useState(false);

  // ─── Email states ─────────────────────────────────────────────
  const [emailTouched, setEmailTouched] = useState(false);
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [emailDomainWarning, setEmailDomainWarning] = useState("");
  const [showEmailSuggestions, setShowEmailSuggestions] = useState(false);

  // ─── Signature states ─────────────────────────────────────────
  const signatureFileRef = useRef(null);
  const [signatureFile, setSignatureFile] = useState(null);
  const [signaturePreview, setSignaturePreview] = useState(null);
  const [isSignatureUploading, setIsSignatureUploading] = useState(false);
  const [signatureRemoved, setSignatureRemoved] = useState(false);

  // ─── Helpers ──────────────────────────────────────────────────
  const isValidEmail = (email = "") => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const levenshteinDistance = (str1, str2) => {
    const matrix = [];
    for (let i = 0; i <= str2.length; i++) matrix[i] = [i];
    for (let j = 0; j <= str1.length; j++) matrix[0][j] = j;
    for (let i = 1; i <= str2.length; i++) {
      for (let j = 1; j <= str1.length; j++) {
        if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1,
            matrix[i][j - 1] + 1,
            matrix[i - 1][j] + 1
          );
        }
      }
    }
    return matrix[str2.length][str1.length];
  };

  const findClosestDomain = (domain) => {
    if (!domain) return null;
    if (COMMON_EMAIL_DOMAINS.includes(domain)) return null;
    let closestDomain = null;
    let minDistance = Infinity;
    for (const commonDomain of COMMON_EMAIL_DOMAINS) {
      const distance = levenshteinDistance(domain, commonDomain);
      if (distance <= 2 && distance < minDistance) {
        minDistance = distance;
        closestDomain = commonDomain;
      }
    }
    return closestDomain;
  };

  const isFormComplete = () => {
    return (
      employeeName.trim() !== "" &&
      mobileNumber.trim() !== "" &&
      emailId.trim() !== "" &&
      Designation.trim() !== "" &&
      userName.trim() !== "" &&
      password.trim() !== "" &&
      DateOfBirth.trim() !== "" &&
      joiningDate.trim() !== "" &&
      category !== "" &&
      !emailInvalid &&
      !mobileError &&
      !usernameError
    );
  };

  // ─── Step navigation ──────────────────────────────────────────
  const handleNextStep = () => setCurrentStep(prev => prev + 1);
  const handlePrevStep = () => setCurrentStep(prev => prev - 1);

  // Called by step 2 (Company Access) when saved — advances to step 3
  const handleCompanyAccessSaved = (companies) => {
    setGrantedCompanies(companies);
    setCurrentStep(3);
  };

  // ─── Default category based on role ──────────────────────────
  useEffect(() => {
    if (mode === "insert") {
      if (isSuperAdmin) setCategory("");              // Super Admin chooses explicitly
      else if (userCategory === "Admin") setCategory("2");        // default: TL
      else if (userCategory === "Team Leader") setCategory("3");  // default: User
    }
  }, [mode, userCategory, isSuperAdmin]);

  // ─── Cleanup timeouts ─────────────────────────────────────────
  useEffect(() => {
    return () => {
      if (mobileCheckTimeout) clearTimeout(mobileCheckTimeout);
      if (usernameCheckTimeout) clearTimeout(usernameCheckTimeout);
      if (emailCheckTimeout) clearTimeout(emailCheckTimeout);
    };
  }, [mobileCheckTimeout, usernameCheckTimeout, emailCheckTimeout]);

  // ─── Global members cache ─────────────────────────────────────
  let membersCache = [];

  // ─── Edit mode: fetch user data ───────────────────────────────
  useEffect(() => {
    if (mode !== "edit" || !UID) return;
    const fetchUserAndParents = async () => {
      try {
        const userRes = await axios.get(`${path}/api/user/${UID}`);
        const userData = userRes.data;

        setEmployeeName(userData.EmployeeName || "");
        setMobileNumber(userData.MobileNo ? userData.MobileNo.toString() : "");
        setEmailId(userData.emailId || "");
        setDesignation(userData.Designation || "");
        setUserName(userData.UserName || "");
        setPassword(userData.Password || "");
        setDateOfBirth(userData.DateOfBirth || "");
        setJoiningDate(userData.JoiningDate || new Date().toISOString().split("T")[0]);
        const matched = categoryOptions.find(o => o.name === userData.UserCategory);
        setCategory(matched ? matched.id : "");
        setOriginalCategory(userData.UserCategory || "");
        setIsActive(!!userData.IsActive);

        if (userData.IsActive === 0) {
          setEnableDays(true);
          setDays(userData.FreezeDays?.toString() || "0");
        } else {
          setEnableDays(false);
          setDays("");
        }

        if (userData.parentUserIds && userData.parentUserIds.length > 0) {
          const allMembers = await fetchTeamLeaders();
          const matchedParents = allMembers.filter(member =>
            userData.parentUserIds.includes(member.UserId)
          );
          setSelectedTeamLeaders(matchedParents);
        }

        // Fetch existing signature
        try {
          const sigRes = await axios.get(`${path}/api/userSignature/Get/${UID}`);
          if (sigRes?.data?.success && sigRes.data.imageBase64) {
            setSignaturePreview(sigRes.data.imageBase64);
            setSignatureFile(null);
          }
        } catch (sigErr) {
          // No signature yet — that's fine
        }
      } catch (error) {
        console.error("Error in edit mode:", error);
        setUpdateMessage("Failed to load user");
        setUpdateStatus("error");
      }
    };
    fetchUserAndParents();
  }, [mode, UID, path, companyId]);

  // ─── API: check username ──────────────────────────────────────
  const checkUsername = async (userNameValue) => {
    if (!userNameValue.trim()) {
      setUsernameError("");
      setUsernameValid(false);
      return;
    }
    setUsernameCheckLoading(true);
    try {
      const res = await axios.post(`${path}/api/checkUsername`, { userName: userNameValue.trim() });
      if (!res.data.unique) {
        setUsernameError(`Taken. Try: ${res.data.suggestions?.join(", ") || ""}`);
        setUsernameValid(false);
      } else {
        setUsernameError("");
        setUsernameValid(true);
      }
    } catch (error) {
      setUsernameError("Check failed");
      setUsernameValid(false);
    } finally {
      setUsernameCheckLoading(false);
    }
  };

  // ─── API: check mobile ────────────────────────────────────────
  const checkMobileNumber = async (mobileValue) => {
    if (!mobileValue.trim() || !/^\d{10}$/.test(mobileValue)) {
      setMobileError("");
      setMobileValid(false);
      return;
    }
    setMobileCheckLoading(true);
    try {
      const res = await axios.get(`${path}/api/user-check-mobile`, {
        params: { mobileNo: mobileValue.trim() }
      });
      if (!res.data.success) {
        setMobileError("");
        setMobileValid(false);
      } else {
        setMobileError("");
        setMobileValid(true);
      }
    } catch (error) {
      setMobileError("Mobile number already exist! Try different one.");
      setMobileValid(false);
    } finally {
      setMobileCheckLoading(false);
    }
  };

  // ─── API: fetch team leaders ──────────────────────────────────
  const fetchTeamLeaders = async (search = "") => {
    if (!companyId || !path) return [];
    try {
      const res = await axios.get(`${path}/api/members`, {
        params: { companyId, search: search.trim() || undefined }
      });
      const data = res.data || [];
      if (!search) membersCache = data;
      return data;
    } catch (err) {
      console.error("Failed to load team leaders", err);
      return [];
    }
  };

  // ─── Signature: file input change ────────────────────────────
  const handleSignatureFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      setSnackbar({ open: true, message: 'Only image files are allowed!', severity: 'error' });
      return;
    }
    setSignatureFile(file);
    setSignatureRemoved(false);
    const reader = new FileReader();
    reader.onloadend = () => setSignaturePreview(reader.result);
    reader.readAsDataURL(file);
  };

  // ─── Signature: remove ────────────────────────────────────────
  const handleSignatureRemove = () => {
    setSignatureFile(null);
    setSignaturePreview(null);
    setSignatureRemoved(true);
    try { if (signatureFileRef.current) signatureFileRef.current.value = ''; } catch (e) {}
  };

  // ─── Signature: delete from server ───────────────────────────
  const deleteSignatureFromServer = async (uid) => {
    if (!uid) return;
    try {
      await axios.delete(`${path}/api/userSignature/Delete/${encodeURIComponent(uid)}`);
    } catch (err) {
      // 404 means no record existed — that's fine
      if (err?.response?.status !== 404) {
        console.error('Signature delete failed:', err);
      }
    }
  };

  // ─── Signature: upload for Insert (base64 JSON POST) ─────────
  const uploadSignatureForInsert = async (newUserId, file) => {
    if (!newUserId || !file) return;
    setIsSignatureUploading(true);
    try {
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
      await axios.post(`${path}/api/userSignature/Insert`, {
        userId: String(newUserId),
        compId: String(companyId || ''),
        AppRegID: String(AppRegID || ''),
        imageBase64: base64,
      }, { headers: { 'Content-Type': 'application/json' } });
    } catch (err) {
      console.error('Signature upload failed:', err);
      setSnackbar({ open: true, message: 'Signature upload failed', severity: 'error' });
    } finally {
      setIsSignatureUploading(false);
    }
  };

  // ─── Signature: upload for Update (multipart PUT) ─────────────
  const uploadSignatureForUpdate = async (uid, file) => {
    if (!uid || !file) return;
    setIsSignatureUploading(true);
    try {
      const fd = new FormData();
      fd.append('signature', file);
      fd.append('compId', String(companyId || ''));
      fd.append('AppRegID', String(AppRegID || ''));
      await axios.put(`${path}/api/userSignature/Update/${encodeURIComponent(uid)}`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    } catch (err) {
      console.error('Signature update failed:', err);
      setSnackbar({ open: true, message: 'Signature update failed', severity: 'error' });
    } finally {
      setIsSignatureUploading(false);
    }
  };

  // ─── Validation ───────────────────────────────────────────────
  const validateFormData = () => {
    let newErrors = {};
    if (!employeeName.trim()) newErrors.employeeName = "Employee Name is required";
    if (!mobileNumber.trim()) newErrors.mobileNumber = "Mobile Number is required";
    else if (!/^\d{10}$/.test(mobileNumber)) newErrors.mobileNumber = "Mobile Number must be 10 digits";
    if (!emailId.trim()) newErrors.emailId = "Email ID is required";
    else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailId)) newErrors.emailId = "Enter a valid email address";
    if (!Designation.trim()) newErrors.Designation = "Designation is required";
    if (!userName.trim()) newErrors.userName = "User Name is required";
    if (!password.trim()) {
      newErrors.password = "Password is required";
      setIsPasswordError(true);
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
      setIsPasswordError(true);
    } else {
      setIsPasswordError(false);
    }
    if (!DateOfBirth.trim()) newErrors.DateOfBirth = "Date of Birth is required";
    if (!joiningDate.trim()) newErrors.joiningDate = "Joining Date is required";
    if (!category) newErrors.category = "Category is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ─── Submit ───────────────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();
    const requiredAction = mode === "edit" ? "edit" : "add";
    if (canAccess && !canAccess("UserMaster", requiredAction)) {
      showAccessDenied?.();
      return;
    }
    setIsSubmitting(true);

    if (mobileError) {
      setUpdateMessage("Please fix the mobile number error");
      setUpdateStatus("error");
      setIsSubmitting(false);
      return;
    }
    if (!path) {
      setUpdateMessage("API connection string is missing");
      setUpdateStatus("error");
      setIsSubmitting(false);
      return;
    }
    if (!companyId) {
      setUpdateMessage("Company ID is missing");
      setUpdateStatus("error");
      setIsSubmitting(false);
      return;
    }
    if (!validateFormData()) {
      setIsSubmitting(false);
      return;
    }

    const selectedCategory = categoryOptions.find(option => option.id === category);
    if (!selectedCategory) {
      setUpdateMessage("Invalid category selected");
      setUpdateStatus("error");
      setIsSubmitting(false);
      return;
    }
    if (!userName.trim()) {
      setUpdateMessage("User Name cannot be empty");
      setUpdateStatus("error");
      setIsSubmitting(false);
      return;
    }

    const payload = {
      AppRegID, employeeName, mobileNumber, emailId, Designation,
      userName, password, DateOfBirth, joiningDate,
      category: selectedCategory.name, IsActive, companyId,
      addUserId: userId,
      editUserId: mode === "edit" ? userId : undefined,
      userId: mode === "edit" ? userId : undefined,
      days: enableDays ? Number(days) : undefined,
      ...(selectedTeamLeaders.length > 0 && {
        parentUserIds: selectedTeamLeaders.map(u => u.UserId)
      })
    };

    try {
      if (mode === "edit" && originalCategory === "Admin" && selectedCategory.name !== "Admin") {
        setUpdateMessage("This user details cannot be modified");
        setUpdateStatus("error");
        setSnackbarOpen(true);
        setIsSubmitting(false);
        return;
      }

      if (mode === "edit" && selectedCategory.name === "User") {
        try {
          // const { data: teamData } = await axios.get(`${path}/api/teamcount/${UID}?companyId=${companyId}`);
          // console.log("Team count data:", teamData);
          // if (teamData.count > 1) {
          //   setUpdateMessage("Cannot change category to 'User' because this user has team members. Please remove team members before changing.");
          //   setUpdateStatus("error");
          //   setSnackbarOpen(true);
          //   setIsSubmitting(false);
          //   setIsPasswordError(false)
          //   return;
          // }
        } catch (error) {
          console.error("Error fetching team count:", error);
          setUpdateMessage("Failed to verify team count");
          setUpdateStatus("error");
          setSnackbarOpen(true);
          setIsSubmitting(false);
          return;
        }
      }

      if (mode === "edit") {
        if (!UID) {
          setUpdateMessage("UserId is missing, cannot update");
          setUpdateStatus("error");
          setIsSubmitting(false);
          return;
        }
        const response = await axios.put(`${path}/api/useredit/${UID}`, payload);
        // ─── Edit: handle signature change/remove ─────────────
        if (signatureFile) {
          await uploadSignatureForUpdate(UID, signatureFile);
        } else if (signatureRemoved) {
          await deleteSignatureFromServer(UID);
        }
        setInsertedUID(UID);
        handleNextStep();

      } else {
        const response = await axios.post(`${path}/api/insertUser`, payload);
        if (response.data.success) {
          const newUserId = response.data.userId;
          // ─── Insert: upload signature if a file was chosen ────
          if (signatureFile) {
            await uploadSignatureForInsert(newUserId, signatureFile);
          }
          setSignatureRemoved(false);
          setInsertedUID(newUserId) // adjust key to match your API response
          handleNextStep();
        } else {
          setUpdateStatus("error");
        }
      }
    } catch (error) {
      console.error("Error processing user details:", error);
      setSnackbarMessage(error.response?.data?.message || "Network error or server is unreachable");
      setUpdateMessage(error.response?.data?.message || "Server error");
      setUpdateStatus("error");
      setSnackbarOpen(true);
    }
    setIsSubmitting(false);
  };



  // ─── Cancel ───────────────────────────────────────────────────
  const handleCancel = () => {
    if (typeof onPopupCancel === 'function') {
      onPopupCancel();
    } else {
      navigate('/main/v3/userdetails');
    }
  };

  const handleCategoryChange = (selectedOption) => {
    setCategory(selectedOption.id);
  };

  // ─── Mobile change handler ────────────────────────────────────
  const handleMobileChange = (e) => {
    const newValue = e.target.value;
    setMobileNumber(newValue);
    setMobileError("");
    setMobileValid(false);
    if (mobileCheckTimeout) clearTimeout(mobileCheckTimeout);
    const timeoutId = setTimeout(() => checkMobileNumber(newValue), 1000);
    setMobileCheckTimeout(timeoutId);
  };

  // ─── Username change handler ──────────────────────────────────
  const handleUsernameChange = (e) => {
    const newValue = e.target.value;
    setUserName(newValue);
    setUsernameError("");
    setUsernameValid(false);
    if (usernameCheckTimeout) clearTimeout(usernameCheckTimeout);
    const timeoutId = setTimeout(() => checkUsername(newValue), 1000);
    setUsernameCheckTimeout(timeoutId);
  };

  // ─── Email change handler ─────────────────────────────────────
  const handleEmailChange = (e) => {
    const newValue = e.target.value;
    setEmailId(newValue);
    setEmailInvalid(false);
    setEmailDomainWarning("");
    if (emailCheckTimeout) clearTimeout(emailCheckTimeout);
    const timeoutId = setTimeout(() => {
      if (!newValue.trim()) { setEmailInvalid(false); setEmailDomainWarning(""); return; }
      if (!isValidEmail(newValue)) { setEmailInvalid(true); setEmailTouched(true); setEmailDomainWarning(""); return; }
      setEmailInvalid(false);
      setEmailTouched(true);
      const domain = newValue.split("@")[1]?.toLowerCase();
      const suggestion = findClosestDomain(domain);
      setEmailDomainWarning(suggestion && domain !== suggestion ? suggestion : "");
    }, 1000);
    setEmailCheckTimeout(timeoutId);
  };

  const handleEmailBlur = () => {
    setTimeout(() => {
      setShowEmailSuggestions(false);
      setEmailTouched(true);
      if (!emailId.trim()) { setEmailInvalid(false); setEmailDomainWarning(""); return; }
      if (!isValidEmail(emailId)) { setEmailInvalid(true); setEmailDomainWarning(""); return; }
      setEmailInvalid(false);
      const domain = emailId.split("@")[1]?.toLowerCase();
      const suggestion = findClosestDomain(domain);
      setEmailDomainWarning(suggestion && domain !== suggestion ? suggestion : "");
    }, 150);
  };

  const handleEmailSuggestionClick = (item) => {
    setEmailId(item);
    setEmailInvalid(false);
    setEmailDomainWarning("");
  };

  // ─── Step 1 props bundle ──────────────────────────────────────
  const stepOneProps = {
    mode,
    employeeName, setEmployeeName,
    mobileNumber,
    emailId,
    Designation, setDesignation,
    userName,
    password, setPassword,
    DateOfBirth, setDateOfBirth,
    joiningDate, setJoiningDate,
    days, setDays,
    enableDays, setEnableDays,
    category,
    IsActive, setIsActive,
    selectedTeamLeaders, setSelectedTeamLeaders,
    errors,
    updateMessage, updateStatus,
    showPassword, setShowPassword,
    isSubmitting,
    isPasswordError,
    usernameError, usernameValid, usernameCheckLoading,
    mobileError, mobileValid, mobileCheckLoading,
    emailTouched, emailInvalid, emailDomainWarning,
    showEmailSuggestions, setShowEmailSuggestions,
    EMAIL_SUGGESTIONS,
    handleSubmit,
    handleCancel,
    handleCategoryChange,
    handleMobileChange,
    handleUsernameChange,
    handleEmailChange,
    handleEmailBlur,
    handleEmailSuggestionClick,
    checkMobileNumber,
    checkUsername,
    fetchTeamLeaders,
    isFormComplete,
    getFutureDate,
    categoryOptions: filteredCategoryOptions,
    navigate,
    toProperCase,
    // ─── Signature props ──────────────────────────────────────
    signaturePreview,
    signatureFileRef,
    isSignatureUploading,
    onSignatureFileChange: handleSignatureFileChange,
    onSignatureRemove: handleSignatureRemove,
  };

  // ─── Step 2 props bundle (Company Access) ────────────────────
  const stepTwoProps = {
    mode,
    insertedUID: insertedUID || UID,
    primaryCompId: companyId,
    adminUserId: userId,
    path,
    AppRegID,
    GCompId: selectedCompany?.GCompId,
    handlePrevStep,
    handleCancel,
    onSaved: handleCompanyAccessSaved,
  };

  // ─── Step 3 props bundle (User Rights) ───────────────────────
  const stepThreeProps = {
    mode,
    insertedUID: insertedUID || UID,
    grantedCompanies: grantedCompanies || (companyId ? [{ CompId: companyId, CompanyName: selectedCompany?.CompanyName || "Company" }] : []),
    path,
    handlePrevStep: () => setCurrentStep(2),
    handleCancel,
    AppRegID,
    GCompId: selectedCompany?.GCompId,
    addUserId: userId,
    newUserCategory: categoryOptions.find(o => o.id === category)?.name || "",
  };

  return (
    <>
      {/* ─── Stepper UI ───────────────────────────────────────── */}
      <Box sx={{ width: '100%', maxWidth: 480, mx: 'auto', pt: 2, px: 2 }}>
        <Stepper activeStep={currentStep - 1} alternativeLabel>
          {STEPS.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>

      {/* ─── Step content ─────────────────────────────────────── */}
      {currentStep === 1 && <UserDetailsStep {...stepOneProps} />}
      {currentStep === 2 && <UserCompanyAccessStep {...stepTwoProps} />}
      {currentStep === 3 && <UserRightsStep {...stepThreeProps} />}

      {/* ─── Snackbars ────────────────────────────────────────── */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UserMaster;